import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { defaultPageSize } from "@modules/content/helpers/content";
import { Card } from "@ui/card";
import { ArrowLeft, Dot } from "lucide-react";
import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";
import { convertMsToHourMinSec } from "@utils/helpers/timeFormtter";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { SVG } from "@components/items/common/SVG";

export interface RelatedCardParameters {
  title: string | null;
  image: string | null;
  coverImage: string | null;
}

const Component = createComponentElement((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<RelatedCardParameters, RelatedCardParameters>(
    {
      ...props,
      pageNumber: 1,
      pageSize: defaultPageSize,
    },
    ref
  );
  const navigate = useAppNavigate();

  const { title, coverImage, image } = getParameterValues([
    "title",
    "coverImage",
    "image",
  ]);

  if (!content) return null;

  return (
    <div className="flex w-full flex-col justify-center gap-4">
      <div className="text-[20px] font-bold dark:text-white">{title}</div>
      <Card
        className="flex w-full cursor-pointer items-start justify-start gap-x-3 rounded-[10px] border-none bg-white p-2 pl-4 shadow-md dark:bg-[#010D19]"
        onClick={() => {
          navigate(`/details/${content.id}`);
        }}
      >
        {image ? (
          <img
            src={getPublicMediaUrl(image)}
            alt="book"
            className="h-[52px] w-[52px] rounded-xl"
          />
        ) : (
          <div className="h-[52px] w-[52px] rounded-xl"></div>
        )}
        <div className="gap-y flex flex-col items-start justify-center">
          <div className="text-[14px] font-medium text-black dark:text-white">
            {content?.title}
          </div>
          <div className="gap-x flex items-center justify-center text-[12px] text-[#898A8D] dark:text-[#FFFFFFB2]">
            <div>{content?.authors?.join(", ")}</div>
            {/* <Dot /> */}
            {/* <div>{convertMsToHourMinSec(content?.durationMS || 0)}</div> */}
          </div>
        </div>
        <div className="ms-auto mt-auto">
          <SVG
            src="/assets/icons/left-arrow.svg"
            preProcessor={(code: string) =>
              code
                .replace(/(fill=)"(?!none")[^"]+"/g, 'fill="currentColor"')
                .replace(/(stroke=)"(?!none")[^"]+"/g, 'stroke="currentColor"')
            }
            className="h-5 w-5 text-black dark:text-white"
          />
        </div>
      </Card>
    </div>
  );
});

export const FullBookRelatedCardComponent: ContentComponent = {
  identifier: "COM:RELATED:CARD",
  component: Component,
};
